import { apiUrl } from '../config';
import { readApiJson } from './apiResponse';
import { filterProductPlans } from './planUtils';

function normalizePlansPayload(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.plans)) return data.plans;
  return [];
}

/**
 * GET /api/plans sin Authorization (endpoint público).
 * @returns {Promise<{ ok: true, plans: object[] } | { ok: false, message: string }>}
 */
export async function fetchPublicPlans() {
  let response;
  try {
    response = await fetch(apiUrl('/api/plans'), {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
  } catch (err) {
    const offline =
      err?.message === 'Failed to fetch' || err?.name === 'TypeError';
    return {
      ok: false,
      message: offline
        ? 'No pudimos conectar con el servidor. Reintentá en unos segundos.'
        : err?.message || 'Error de conexión al cargar los planes.',
    };
  }

  try {
    if (!response.ok) {
      let detail = '';
      try {
        const body = await readApiJson(response);
        detail = body?.message || body?.error || '';
      } catch {
        detail = '';
      }
      return {
        ok: false,
        message:
          detail ||
          'No pudimos cargar los planes. Reintentá en unos segundos o recargá la página.',
      };
    }

    const data = await readApiJson(response);
    const raw = normalizePlansPayload(data);
    const plans = filterProductPlans(raw);
    if (plans.length === 0) {
      return {
        ok: false,
        message:
          'No hay planes disponibles en este momento. Si el problema persiste, contactanos.',
      };
    }
    return { ok: true, plans };
  } catch (err) {
    return {
      ok: false,
      message:
        err?.message ||
        'No pudimos cargar los planes. Reintentá en unos segundos o recargá la página.',
    };
  }
}
